/**
 * A small plane, nose to the right (east) in a 20 x 20 box centred on 0,0, so rotating it by
 * the direction of travel (or heading - 90) points it the way it's flying.
 */
export const PLANE_PATH =
  'M9.5 0 Q9.5 -1.2 7.5 -1.2 L2 -1.2 L-2.5 -7 L-4.6 -7 L-2.4 -1.2 L-6.2 -1.2 L-7.8 -3.2 L-9 -3.2 L-8 0 L-9 3.2 L-7.8 3.2 L-6.2 1.2 L-2.4 1.2 L-4.6 7 L-2.5 7 L2 1.2 L7.5 1.2 Q9.5 1.2 9.5 0 Z';
